<template>
  <section class="store-item">
    <div class="flex webkit-box space-between align-center header">
      <div class="flex webkit-box align-center flex-1 store-info">
        <van-image class="store-item-img" width="20px" fit="cover" height="20px" :src="store.storeImg | storeImg" />
        <p class="van-ellipsis store-item-title">
          {{ !isPickOrder ? '智云合作供应商' : store.storeName || '智云合作供应商' }}
        </p>
        <div v-if="isSplitOrder" class="store-item-split-tag" style="margin-left: 4px">
          <span>拆单</span>
        </div>

        <div v-if="isPickOrder" class="store-item-split-tag" :style="{ 'margin-left': isSplitOrder ? '0' : '4px' }">
          <span>自提</span>
        </div>
        <div v-else class="store-item-split-tag" :style="{ 'margin-left': isSplitOrder ? '0' : '4px' }">
          <span>快递</span>
        </div>
      </div>
      <div v-if="isPickOrder" class="store-item-distance">
        {{ (distanceMap[supplierId] && distanceMap[supplierId].distance) || store.distance | distance }}
      </div>
    </div>

    <p v-if="store.storeAddress && isPickOrder" class="store-item-address">{{ store.storeAddress }}</p>

    <!-- 商品列表slot -->
    <slot />
  </section>
</template>

<script>
import zyydLogo from '@/assets/imgs/zyjk-logo.png';
import jumpCenter from '@/mixins/jumpCenter';
export default {
  name: 'StoreCard',
  mixins: [jumpCenter],
  filters: {
    storeImg(val) {
      if (!val) return zyydLogo;
      return val;
    }
  },
  props: {
    store: {
      type: Object,
      default: () => ({
        storeName: '',
        storeAddress: '',
        storeImg: ''
      })
    },
    isOrderList: {
      // 是否是订单列表
      type: Boolean,
      default: true
    },
    isSplitOrder: {
      // 是否拆单
      type: Boolean,
      default: false
    },
    isPickOrder: {
      // 是否自提
      type: Boolean,
      default: false
    },
    distanceMap: {
      // 供应商距离map
      type: Object,
      default: () => {}
    },
    supplierId: {
      type: String | Number,
      default: ''
    }
  }
};
</script>

<style lang="less" scoped>
.store-item {
  background: #fff;
  padding: 0 12px;
  color: #262626;
  font-size: 12px;
  &-go {
    color: #bfbfbf;
    display: block;
    line-height: 1;
  }
  &-title {
    font-size: 14px;
    font-weight: 400;
    max-width: 140px;
  }
  &-distance,
  &-address {
    color: #8c8c8c;
    font-size: 12px;
  }
  &-distance {
    line-height: 20px;
    padding: 14px 0 10px;
    min-width: 80px;
    text-align: right;
  }
  div.store-info {
    width: 100%;
    line-height: 1;
    font-weight: 500;
    padding: 14px 0 10px 2px;
    p {
      max-height: 100%;
    }
  }
  &-split-tag {
    min-width: 24px;
    border-radius: 2.5px;
    font-size: 12px;
    background: #ebf8ff;
    color: #1e8dff;
    width: 30px;
    height: 17.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.8);
  }
  &-img {
    margin-right: 8px;
    vertical-align: middle;
    border-radius: 2px;
    overflow: hidden;
    min-width: 20px;
  }
  &-status {
    color: #8c8c8c;
    background: #f5f5f5;
    padding: 4px 8px;
    font-size: 14px;
    border-radius: 16px;
  }
  &-price {
    text-align: right;
    line-height: 1;
    padding-top: 16px;
  }
  &-btn {
    text-align: right;
    padding-top: 12px;
  }
  /deep/ .van-button {
    width: 88px;
    margin-left: 8px;
  }
  .gary {
    color: #595959;
    border-color: #d9d9d9;
  }
}
</style>
